import React, { useState, useEffect, useRef } from 'react';
import FilterBar from '../../../components/FilterBar';
import { useDispatch, useSelector } from 'react-redux';
import { Col, ConfigProvider, Row, Select, Tabs, DatePicker } from 'antd';
import { IoArrowBack } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import BasicDrawer from '../../../components/Drawer';
import BasicText from '../../../components/Text/BasicText';
import { Colors } from '../../../config';
import AssignShiftDrawer from './assignShiftDrawer';
import filter from '../../../assets/images/filter.png';
import { Button, Pagination } from '../../../components';
import App from './App';
import moment from 'moment';
import { ShiftSchedulerAction } from '../../../store/actions';
import Circular from '../../../components/Loader/Circular';
import { PlusOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import {
    getAllProperties,
    getAllUsers,
    getEligibiity,
    getSchedules,
    getLocationsByProperty,
} from '../../../config/getApis';
import avatar from '../../../assets/images/avatar.jpg';
import DetailShiftDrawer from './detailShiftDrawer';
import useColors from '../../../hooks/useColors';
import { FaFilter } from 'react-icons/fa6';
import dayjs from 'dayjs';
import currentDate from '../../../config/util/index';
import { ViewType } from './react-big-schedule/dist';
import LoadOnScroll from '../../../components/LoadOnScroll';

const MyShifts = () => {
    const { colorPrimary } = useColors();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const scrollContainerRef = useRef(null);

    const { user } = useSelector((state) => state?.AppReducer);
    const userRole = user?.userRole[0];

    console.log('userRole', user);

    const { loader, potentialTakersLoader, shiftsData } = useSelector(
        (state) => state?.ShiftSchedulerReducer,
    );
    const { data: shiftRecords, paginate } = shiftsData;
    console.log('shifts records data', potentialTakersLoader, loader, shiftRecords);
    const users = localStorage.getItem('user'); // Get the user data from localStorage
    if (users) {
        try {
            const parsedUser = JSON.parse(users); // Parse the JSON string
            const userId = parsedUser?.id; // Access the `id` property
            if (userId) {
                console.log('User ID:', userId);
            } else {
                console.error('User ID not found in the parsed data.');
            }
        } catch (error) {
            console.error(
                'Failed to parse user data from localStorage:',
                error,
            );
        }
    } else {
        console.error('User data not found in localStorage.');
    }

    const [state, setState] = useState({
        limit: 100,
        page: 1,
        tabKey: 0,
        filterDrawer: {
            schedule: '',
            user: '',
            eligiblity: '',
            jobSite: '',
            location: '',
            shiftDate: '',
        },
    });

    const [openShiftDetail, setOpenShiftDetail] = useState(null);
    const [filterQueryParams, setFilterQueryParams] = useState('');
    const [shiftsHasMore, setShiftsHasMore] = useState(true);
    const [fetchingConditionally, setFetchingConditionally] = useState(false);
    const [totalScheduleObjectCount, setTotalScheduleObjectCount] = useState(0);
    const [forceFullyStopHasMoreShifts, setForceFullyStopHasMoreShifts] =
        useState(false);
    const [propertyLocations, setPropertyLocations] = useState([]);
    const [paginationMetadata, setPaginationMetadata] = useState(null);
    const loadMoreRef = useRef(null);

    const handleLoadMore = () => {
        if (loadMoreRef.current) {
            loadMoreRef.current();
        }
    };

    const [currentConfigOfScheduler, setCurrentConfigOfScheduler] = useState({
        date: dayjs().format('YYYY-MM-DD') || currentDate(),
        viewType: ViewType?.Week,
    });

    // clearing shifts on unmounting as it is creating a repetative data once the component get mounts again.
    useEffect(() => {
        return () => {
            dispatch(ShiftSchedulerAction.ClearShifts());
        };
    }, []);

    // Scroll to top when new data is updated
    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                top: 0,
                behavior: 'smooth', // remove 'smooth' if you want instant scroll
            });
        }
    }, [state?.page]); // Trigger whenever `data` changes

    // useEffect(() => {
    //     dispatch(ShiftSchedulerAction.GetMyShift(state));
    // }, []);

    const [drawerStates, setDrawerStates] = useState({
        assignShiftDrawer: false,
        shiftTypeDrawer: false,
        typeOfShift: '',
        filter: false,
        openShiftDetailDrawer: false,
    });

    const [resources, setResources] = useState([]);
    const [events, setEvents] = useState([]);

    // const shiftDetailHandler = (openShiftDetail) => {
    //     setDrawerStates({ ...drawerStates, openShiftDetailDrawer: true });
    //     setOpenShiftDetail(openShiftDetail);
    // };
    const shiftDetailHandler = (
        openShiftDetail,
        allowNew = false,
        isOpenShift,
    ) => {
        setOpenShiftDetail(openShiftDetail);
        if (allowNew) {
            setDrawerStates((prev) => ({
                ...prev,
                assignShiftDrawer: false,
                shiftTypeDrawer: true,
                typeOfShift: isOpenShift ? 'open' : 'normal',
            }));
        } else {
            setDrawerStates({ ...drawerStates, openShiftDetailDrawer: true });
        }
        // setDrawerStates({ ...drawerStates, assignShiftDrawer: true });
    };

    useEffect(() => {
        // setResources([]);
        // setEvents([]);
        if (shiftRecords?.length > 0 || shiftRecords?.length == 0) {
            // paginate is missing whenever the store was cleared (ClearShifts) or the
            // response has no pagination block, so it must be optional here.
            let findCurrent = paginate?.currentPage == 1;

            let updatedResources = findCurrent ? [] : [...resources];
            let updatedEvents = findCurrent ? [] : [...events];

            // let findShift = shiftRecords && shiftRecords[0]?.openShift;
            // if (findShift) {
            //     setState({ ...state, tabKey: 1 });
            // } else {
            //     setState({ ...state, tabKey: 0 });
            // }

            for (let item of shiftRecords) {
                let appliedUsers = (item?.shiftUser || []).filter((item) => {
                    return item?.status == 'applied';
                });

                let acceptedUsers = (item?.shiftUser || []).filter((item) => {
                    return item?.status == 'accepted';
                });

                let noOfAssigness = item?.numberOfAssignees;

                const startDate = item.shiftDate
                // item.shiftDate !== null ? item.shiftDate : item.startDate;
                const endDate = item.shiftDate
                // item.endDate || item.shiftDate;

                const startTimeString = `${startDate} ${item.startTime}`;
                const endTimeString = `${endDate} ${item.endTime}`;

                const startTimeMoment = moment(
                    startTimeString,
                    'YYYY-MM-DDThh:mm:ss',
                );
                const endTimeMoment = moment(
                    endTimeString,
                    'YYYY-MM-DDThh:mm:ss',
                );

                if (item?.shiftUser?.length > 0) {
                    for (let Users of item?.shiftUser) {
                        let alreadyAddedResourceId = null;
                        if (state?.tabKey == 0) {
                            if (updatedResources?.length > 0) {
                                const alreadyAddedResource =
                                    updatedResources?.find(
                                        (resource) =>
                                            resource?.email ==
                                            Users?.user?.email,
                                    );
                                const alreadyAddedResourceIdex =
                                    updatedResources?.findIndex(
                                        (resource) =>
                                            resource?.email ==
                                            Users?.user?.email,
                                    );
                                if (alreadyAddedResource) {
                                    alreadyAddedResourceId =
                                        alreadyAddedResource?.id;
                                    const mutatedResourceObject = {
                                        ...alreadyAddedResource,
                                        count: alreadyAddedResource?.count + 1,
                                    };
                                    updatedResources?.splice(
                                        alreadyAddedResourceIdex,
                                        1,
                                        mutatedResourceObject,
                                    );
                                } else {
                                    updatedResources?.push({
                                        id: Users?.user?.id,
                                        name:
                                            Users?.user?.firstName +
                                            ' ' +
                                            Users?.user?.lastName,
                                        image: Users?.user?.profileImg
                                            ? Users?.user?.profileImg[0]?.url
                                            : avatar,
                                        phoneNo: Users?.user?.phoneNo,
                                        email: Users?.user?.email,
                                        assignee: Users?.assignee,
                                        count: 1,
                                    });
                                }
                            } else {
                                updatedResources?.push({
                                    id: Users?.user?.id,
                                    name:
                                        Users?.user?.firstName +
                                        ' ' +
                                        Users?.user?.lastName,
                                    image: Users?.user?.profileImg
                                        ? Users?.user?.profileImg[0]?.url
                                        : avatar,
                                    phoneNo: Users?.user?.phoneNo,
                                    email: Users?.user?.email,
                                    assignee: Users?.assignee,
                                    count: 1,
                                });
                            }
                            // resources?.push({
                            //     id: Users?.id,
                            //     name:
                            //         Users?.user?.firstName +
                            //         ' ' +
                            //         Users?.user?.lastName,
                            //     image: Users?.user?.profileImg
                            //         ? Users?.user?.profileImg[0]?.url
                            //         : avatar,
                            // });

                            updatedEvents.push({
                                id: item?.id,
                                break: item?.break,
                                howMany: item?.howMany,
                                start: startTimeMoment,
                                end: endTimeMoment,
                                property: item?.property
                                    ? item?.property?.name
                                    : '',
                                resourceId:
                                    alreadyAddedResourceId !== null
                                        ? alreadyAddedResourceId
                                        : Users?.id,
                                title: startTimeString + ' - ' + endTimeString,
                                bgColor:
                                    Users?.status == 'accepted'
                                        ? '#5fdba7'
                                        : item.siteColor || colorPrimary + '50',
                                location: item?.address
                                    ? `${item.address?.streetNumber},${item.address?.streetName},${item.address?.city},${item.address?.buildingNumber}`
                                    : '',
                                Eligibility: item?.eligibilitity
                                    ? item?.eligibilitity?.name
                                    : '',
                                Schedules:
                                    Users?.user?.schedules?.[0]?.name + '...',
                                assignedBy: Users?.assignee
                                    ? Users?.assignee?.firstName +
                                    ' ' +
                                    Users.assignee?.lastName
                                    : '-',
                                assignedByImage:
                                    Users?.user?.profileImg?.[0]?.url,
                                // 'https://fastly.picsum.photos/id/1/200/300.jpg?hmac=jH5bDkLr6Tgy3oAg5khKCHeunZMHq0ehBZr6vGifPLY',
                                duration: `${startTimeString} - ${endTimeString}`,
                                status: Users?.status,
                                tabKey: state?.tabKey,
                                completeRecord: item,
                                shiftDetailHandler,

                            });
                        } else {
                            if (
                                appliedUsers?.length > 0 &&
                                Users?.status == 'applied' &&
                                acceptedUsers?.length < noOfAssigness
                            ) {
                                if (updatedResources?.length > 0) {
                                    const alreadyAddedResource =
                                        updatedResources?.find(
                                            (resource) =>
                                                resource?.email ==
                                                Users?.user?.email,
                                        );
                                    const alreadyAddedResourceIdex =
                                        updatedResources?.findIndex(
                                            (resource) =>
                                                resource?.email ==
                                                Users?.user?.email,
                                        );
                                    if (alreadyAddedResource) {
                                        alreadyAddedResourceId =
                                            alreadyAddedResource?.id;
                                        const mutatedResourceObject = {
                                            ...alreadyAddedResource,
                                            count:
                                                alreadyAddedResource?.count + 1,
                                        };
                                        updatedResources?.splice(
                                            alreadyAddedResourceIdex,
                                            1,
                                            mutatedResourceObject,
                                        );
                                    } else {
                                        updatedResources?.push({
                                            id: appliedUsers[0]?.id,
                                            name:
                                                'Unassigned \n' +
                                                'Applied :' +
                                                appliedUsers?.length +
                                                '\nAvailable Slots:' +
                                                noOfAssigness,
                                            image: avatar,
                                            phoneNo: Users?.user?.phoneNo,
                                            email: Users?.user?.email,
                                            assignee: Users?.assignee,
                                            count: 1,
                                        });
                                    }
                                } else {
                                    updatedResources?.push({
                                        id: appliedUsers[0]?.id,
                                        name:
                                            'Unassigned \n' +
                                            'Applied : ' +
                                            appliedUsers?.length +
                                            '\nAvailable Slots:' +
                                            noOfAssigness,
                                        image: avatar,
                                        phoneNo: Users?.user?.phoneNo,
                                        email: Users?.user?.email,
                                        assignee: Users?.assignee,
                                        count: 1,
                                    });
                                }

                                // resources?.push({
                                //     id: appliedUsers[0]?.id,
                                //     name:
                                //         'Unassigned ' +
                                //         appliedUsers?.length +
                                //         '/' +
                                //         noOfAssigness,
                                //     image: avatar,
                                //     phoneNo: Users?.user?.phoneNo,
                                //     email: Users?.user?.email,
                                //     assignee: Users?.assignee
                                // });

                                updatedEvents?.push({
                                    id: item?.id,
                                    break: item?.break,
                                    howMany: item?.howMany,
                                    start: startTimeMoment,
                                    end: endTimeMoment,
                                    property: item?.property
                                        ? item?.property?.name
                                        : '',
                                    resourceId:
                                        alreadyAddedResourceId !== null
                                            ? alreadyAddedResourceId
                                            : appliedUsers[0]?.id,
                                    title:
                                        startTimeString + ' - ' + endTimeString,
                                    bgColor:
                                        item.siteColor || colorPrimary + '50',
                                    location: item?.address
                                        ? `${item.address?.streetNumber},${item.address?.streetName},${item.address?.city},${item.address?.buildingNumber}`
                                        : '',
                                    Eligibility: item?.eligibilitity
                                        ? item?.eligibilitity?.name
                                        : '',
                                    Schedules: '-',
                                    assignedBy: appliedUsers[0]?.assignee
                                        ? appliedUsers[0]?.assignee?.firstName +
                                        ' ' +
                                        appliedUsers[0]?.assignee?.lastName
                                        : '-',
                                    duration: `${startTimeString} - ${endTimeString}`,
                                    status: appliedUsers[0]?.status,
                                    tabKey: state?.tabKey,
                                    completeRecord: item,
                                    shiftDetailHandler,
                                });

                                appliedUsers = [];
                            } else if (Users?.status !== 'applied') {
                                if (updatedResources?.length > 0) {
                                    const alreadyAddedResource =
                                        updatedResources?.find(
                                            (resource) =>
                                                resource?.email ==
                                                Users?.user?.email,
                                        );
                                    const alreadyAddedResourceIdex =
                                        updatedResources?.findIndex(
                                            (resource) =>
                                                resource?.email ==
                                                Users?.user?.email,
                                        );
                                    if (alreadyAddedResource) {
                                        alreadyAddedResourceId =
                                            alreadyAddedResource?.id;
                                        const mutatedResourceObject = {
                                            ...alreadyAddedResource,
                                            count:
                                                alreadyAddedResource?.count + 1,
                                        };
                                        updatedResources?.splice(
                                            alreadyAddedResourceIdex,
                                            1,
                                            mutatedResourceObject,
                                        );
                                    } else {
                                        updatedResources?.push({
                                            id: Users?.user?.id,
                                            name:
                                                Users?.user?.firstName +
                                                ' ' +
                                                Users?.user?.lastName,
                                            image: Users?.user?.profileImg
                                                ? Users?.user?.profileImg[0]
                                                    ?.url
                                                : avatar,
                                            phoneNo: Users?.user?.phoneNo,
                                            email: Users?.user?.email,
                                            assignee: Users?.assignee,
                                            count: 1,
                                        });
                                    }
                                } else {
                                    updatedResources?.push({
                                        id: Users?.user?.id,
                                        name:
                                            Users?.user?.firstName +
                                            ' ' +
                                            Users?.user?.lastName,
                                        image: Users?.user?.profileImg
                                            ? Users?.user?.profileImg[0]?.url
                                            : avatar,
                                        phoneNo: Users?.user?.phoneNo,
                                        email: Users?.user?.email,
                                        assignee: Users?.assignee,
                                        count: 1,
                                    });
                                }

                                // resources?.push({
                                //     id: Users?.id,
                                //     name:
                                //         Users?.user?.firstName +
                                //         ' ' +
                                //         Users?.user?.lastName,
                                //     image: Users?.user?.profileImg
                                //         ? Users?.user?.profileImg[0]?.url
                                //         : avatar,
                                //     phoneNo: Users?.user?.phoneNo,
                                //     email: Users?.user?.email,
                                //     assignee: Users?.assignee
                                // });

                                updatedEvents?.push({
                                    id: item?.id,
                                    break: item?.break,
                                    howMany: item?.howMany,
                                    start: startTimeMoment,
                                    end: endTimeMoment,
                                    property: item?.property
                                        ? item?.property?.name
                                        : '',
                                    resourceId:
                                        alreadyAddedResourceId !== null
                                            ? alreadyAddedResourceId
                                            : Users?.id,
                                    title:
                                        startTimeString + ' - ' + endTimeString,
                                    bgColor: '#428A42',
                                    location: item?.address
                                        ? `${item.address?.streetNumber},${item.address?.streetName},${item.address?.city},${item.address?.buildingNumber}`
                                        : '',
                                    Eligibility: item?.eligibilitity
                                        ? item?.eligibilitity?.name
                                        : '',
                                    Schedules:
                                        Users?.user?.schedules?.[0]?.name +
                                        '...',
                                    assignedBy: Users?.assignee
                                        ? Users?.assignee?.firstName +
                                        ' ' +
                                        Users.assignee?.lastName
                                        : '-',
                                    duration: `${startTimeString} - ${endTimeString}`,
                                    status: Users?.status,
                                    tabKey: state?.tabKey,
                                    completeRecord: item,
                                    shiftDetailHandler,

                                });
                            }
                        }
                    }
                } else if (state?.tabKey !== 0) {
                    updatedResources?.push({
                        id: item?.id,
                        name:
                            'Unassigned \n' +
                            'Applied : 0' +
                            '\nAvailable Slots:' +
                            noOfAssigness,
                        image: avatar,
                    });

                    updatedEvents?.push({
                        id: item?.id,
                        break: item?.break,
                        howMany: item?.howMany,
                        start: startTimeMoment,
                        end: endTimeMoment,
                        property: item?.property ? item?.property?.name : '',
                        resourceId: item?.id,
                        title: startTimeString + ' - ' + endTimeString,
                        bgColor: item.siteColor || colorPrimary + '50',
                        location: item?.address
                            ? `${item.address?.streetNumber},${item.address?.streetName},${item.address?.city},${item.address?.buildingNumber}`
                            : '',
                        Eligibility: item?.eligibilitity
                            ? item?.eligibilitity?.name
                            : '',
                        Schedules: '-',
                        assignedBy: '-',
                        duration: `${startTimeString} - ${endTimeString}`,
                        status: 'not applied',
                        tabKey: state?.tabKey,
                        completeRecord: item,
                        shiftDetailHandler,
                    });

                    appliedUsers = [];
                }
            }

            setResources(updatedResources);
            setEvents(updatedEvents);
        }
    }, [shiftRecords, state?.tabKey]);

    const { data: eligibilityOptions } = useQuery('eligiblity', getEligibiity, {
        enabled: drawerStates.filter,
    });
    const { data: scheduleOptions } = useQuery('schedule', getSchedules, {
        enabled: drawerStates.filter,
    });
    const { data: usersOptions } = useQuery('users', getAllUsers, {
        enabled: drawerStates.filter,
    });

    const { data: propertiesRaw } = useQuery(
        'properties',
        getAllProperties,
        {
            enabled: drawerStates.filter,
        },
    );

    const propertiesOptions = (propertiesRaw || []).map((p) => ({
        label: p.name,
        value: p.id,
    }));

    // Fetch locations when property is selected
    useEffect(() => {
        const fetchLocations = async () => {
            if (state?.filterDrawer?.jobSite) {
                const locations = await getLocationsByProperty(
                    state.filterDrawer.jobSite,
                );
                setPropertyLocations(locations);
            } else {
                setPropertyLocations([]);
                // Clear location when property is deselected
                if (state?.filterDrawer?.location) {
                    setState((prev) => ({
                        ...prev,
                        filterDrawer: {
                            ...prev.filterDrawer,
                            location: '',
                        },
                    }));
                }
            }
        };
        fetchLocations();
    }, [state?.filterDrawer?.jobSite]);

    // to select a shift from open or normal
    const assignShiftHandler = () => {
        setDrawerStates({ ...drawerStates, assignShiftDrawer: true });
    };

    // type of drawer open on the basis of type selection for shift
    const shiftTypeHandler = (type) => {
        if (type == 'open') {
            setDrawerStates((prev) => ({
                ...prev,
                assignShiftDrawer: false,
                shiftTypeDrawer: true,
                typeOfShift: type,
            }));
            return;
        } else {
            setDrawerStates((prev) => ({
                ...prev,
                assignShiftDrawer: false,
                shiftTypeDrawer: true,
                typeOfShift: type,
            }));
            return;
        }
    };

    const paginationHandler = (page, limit) => {
        const { schedule, user, eligiblity, jobSite, location, shiftDate } =
            state?.filterDrawer;
        const { tabKey } = state;
        setState((prev) => ({
            ...prev,
            page: page,
            limit: 5,
            filterDrawer: {
                schedule: schedule,
                user: user,
                eligiblity: eligiblity,
                jobSite: jobSite,
                location: location,
                shiftDate: shiftDate,
            },
        }));
        setResources([]);
        setEvents([]);
        dispatch(
            ShiftSchedulerAction.GetMyShift({
                page,
                limit,
                tabKey,
                filterDrawer: {
                    schedule: schedule,
                    user: user,
                    eligiblity: eligiblity,
                    jobSite: jobSite,
                    location: location,
                    shiftDate: shiftDate,
                },
            }),
        );
    };

    // filter search handler
    const incidentFilters = () => {
        const { schedule, user, eligiblity, jobSite, location, shiftDate } =
            state.filterDrawer;

        let values = Object.values(state.filterDrawer).some(
            (item) => item !== '',
        );
        if (!values) {
            return;
        } else {
            setState((prev) => ({
                ...prev,
                page: 1,
                filterDrawer: {
                    schedule: schedule,
                    user: user,
                    eligiblity: eligiblity,
                    jobSite: jobSite,
                    location: location,
                    shiftDate: shiftDate,
                },
            }));
            let payload = {
                limit: state?.limit,
                page: 1,
                tabKey: state?.tabKey,
                filterDrawer: {
                    schedule: schedule ? schedule : '',
                    user: user ? user : '',
                    eligiblity: eligiblity ? eligiblity : '',
                    jobSite: jobSite ? jobSite : '',
                    location: location ? location : '',
                    shiftDate: shiftDate ? shiftDate : '',
                },
            };
            setResources([]);
            setEvents([]);
            // dispatch(ShiftSchedulerAction.GetMyShift(payload));
            setDrawerStates({ ...drawerStates, filter: false });
            setFetchingConditionally(true);
            setForceFullyStopHasMoreShifts(false);
            setTotalScheduleObjectCount(0);
            setFilterQueryParams(
                `&schedule_id=${payload?.filterDrawer?.schedule}&eligibility_id=${payload?.filterDrawer?.eligiblity}&property_id=${payload?.filterDrawer?.jobSite}&location_id=${payload?.filterDrawer?.location}&shift_date=${payload?.filterDrawer?.shiftDate}`,
            );
        }
    };

    // Filter states cleaner
    const clearFilters = () => {
        if (drawerStates.filter) {
            setState((prev) => ({
                ...prev,
                limit: state?.limit,
                page: 1,
                filterDrawer: {
                    schedule: '',
                    user: '',
                    eligiblity: '',
                    jobSite: '',
                    location: '',
                    shiftDate: '',
                },
            }));
            let payload = {
                limit: state?.limit,
                page: 1,
                tabKey: state?.tabKey,
                filterDrawer: {
                    schedule: '',
                    user: '',
                    eligiblity: '',
                    jobSite: '',
                    location: '',
                    shiftDate: '',
                },
            };
            setResources([]);
            setEvents([]);
            // dispatch(ShiftSchedulerAction.GetMyShift(payload));
            setDrawerStates({ ...drawerStates, filter: false });
            dispatch(ShiftSchedulerAction.ClearShifts());
            setFetchingConditionally(true);
            setForceFullyStopHasMoreShifts(false);
            setTotalScheduleObjectCount(0);
            setFilterQueryParams('');
        }
        return;
    };

    const tabChangeHandler = (activeKey) => {
        setState({
            ...state,
            page: 1,
            tabKey: activeKey,
            filterDrawer: { ...state.filterDrawer },
        });
        // dispatch(
        //     ShiftSchedulerAction.GetMyShift({
        //         ...state,
        //         tabKey: activeKey,
        //         page: 1,
        //     }),
        // );
        dispatch(ShiftSchedulerAction.ClearShifts());
        setFetchingConditionally(true);
        setForceFullyStopHasMoreShifts(false);
        setTotalScheduleObjectCount(0);
        setEvents([]);
        setResources([]);
    };

    // data receiving from the scroller component.
    const schedulerScrollDataHandler = (resp) => {
        dispatch(ShiftSchedulerAction.GetMyShiftSuccess(resp?.data));
        // handling forcefully stop hasMore scenerio for the scroll component to not show loading state.
        let totalCurrentSchedulesCount =
            totalScheduleObjectCount + state?.limit;
        if (totalCurrentSchedulesCount >= resp?.data?.paginate?.total) {
            setForceFullyStopHasMoreShifts(true);
        } else {
            setForceFullyStopHasMoreShifts(false);
        }
        setTotalScheduleObjectCount(totalCurrentSchedulesCount);
        setState({ ...state, page: resp?.data?.paginate?.currentPage });
        return resp?.data?.data;
    };

    const setFetchingConditinonallySuccessCallback = () => {
        setFetchingConditionally(false);
    };

    const [ShiftLoader, setShiftLoader] = useState(false);
    return (
        <>
            <BasicDrawer
                openDrawer={drawerStates?.assignShiftDrawer}
                width={400}
                title={'Select the type of Shift'}
                onClose={() =>
                    setDrawerStates((prev) => ({
                        ...prev,
                        assignShiftDrawer: false,
                    }))
                }
                children={
                    <Row
                        className="w-full mt-4 flex justify-around gap-3 flex-wrap"
                        gutter={[16, 32]}
                    >
                        <Col
                            span={10}
                            onClick={() => shiftTypeHandler('open')}
                            style={{ background: colorPrimary, color: 'white' }}
                            className="flex items-center justify-center rounded-md p-4 cursor-pointer hover:scale-x-105 hover:scale-y-105 duration-500 ease-in-out delay-75"
                        >
                            <div>
                                <BasicText
                                    text={'Open Shift'}
                                    className="text-lg "
                                />
                            </div>
                        </Col>

                        <Col
                            span={10}
                            onClick={() => shiftTypeHandler('normal')}
                            style={{ background: colorPrimary, color: 'white' }}
                            className="flex items-center justify-center gap-3 p-4 rounded-md cursor-pointer hover:scale-x-105 hover:scale-y-105 duration-500 ease-in-out delay-75"
                        >
                            <div>
                                <BasicText
                                    text={'Normal Shift'}
                                    className="text-lg "
                                />
                            </div>
                        </Col>
                    </Row>
                }
            />

            <AssignShiftDrawer
                drawerStates={drawerStates}
                setDrawerStates={setDrawerStates}
                shiftState={state}
                setShiftState={setState}
                setOpenShiftDetail={setOpenShiftDetail}
                openShiftDetail={openShiftDetail}
            />

            {/* scheduler component */}
            <Row
                className="w-full py-5 px-2"
                style={{ width: '100%', background: 'white' }}
            >
                <Col
                    span={24}
                    className="px-2 flex items-center justify-between gap-3 flex-wrap"
                >
                    <div className="flex items-center gap-3 min-w-0 flex-wrap">
                        <div
                            className="flex items-center gap-2 cursor-pointer shrink-0"
                            onClick={() => navigate('/workforce-management')}
                            style={{ color: '#555', userSelect: 'none' }}
                        >
                            <IoArrowBack size={18} />
                            {/* <span>Back</span> */}
                        </div>
                        <BasicText
                            text={'Workforce Management - My Shifts'}
                            className="text-lg md:text-xl font-semibold"
                        />
                    </div>

                    <FaFilter
                        size={35}
                        color="white"
                        style={{ background: colorPrimary, flexShrink: 0 }}
                        className="cursor-pointer p-2 rounded-md"
                        onClick={() =>
                            setDrawerStates({ ...drawerStates, filter: true })
                        }
                    />
                </Col>

                {/* <Col span={24} className="mt-4">
                    <Tabs
                        type="card"
                        activeKey={state?.tabKey}
                        onChange={ShiftLoader ? () => { } : tabChangeHandler}
                        defaultActiveKey={state?.tabKey}
                        items={[
                            {
                                label: `Normal Shifts`,
                                key: 0,
                                children: ``,
                            },
                            {
                                label: `Open Shifts`,
                                key: 1,
                                children: ``,
                            },
                        ]}
                    />
                </Col> */}

                {
                    // false ? (
                    //     <Circular
                    //         spinning={loader}
                    //         size={40}
                    //         color={colorPrimary}
                    //         containerStyle={{
                    //             width: '100%',
                    //             height: '100%',
                    //             display: 'flex',
                    //             alignItems: 'center',
                    //             justifyContent: 'center',
                    //         }}
                    //     />
                    // ) :
                    (
                        <>
                            <div
                                id="scrollableMyShiftDiv"
                                ref={scrollContainerRef}
                                style={{
                                    // height: 200,
                                    // maxHeight: 300,
                                    overflow: 'auto',
                                    width: '100%',
                                }}
                            >
                                <LoadOnScroll
                                    endPoint={`/shifts`}
                                    restQueryParams={`perPage=${state?.limit}&open_shift=${0}&user_id=${user?.id}${filterQueryParams?.length > 0 ? filterQueryParams : ''}`}
                                    restQueryOpenShiftParams={`perPage=${state?.limit}&open_shift=${1}&user_id=${user?.id}${filterQueryParams?.length > 0 ? filterQueryParams : ''}`}

                                    // height={300}
                                    scrollableTarget="scrollableMyShiftDiv"
                                    hasMore={shiftsHasMore}
                                    setHasMore={setShiftsHasMore}
                                    // fetching conditionally case when we are assigning shift then we have to fetched the data to update.
                                    isFetchConditionally={fetchingConditionally}
                                    // callback from the child to parent.
                                    callback={
                                        setFetchingConditinonallySuccessCallback
                                    }
                                    scrollItems={events}
                                    scrollDataHandler={schedulerScrollDataHandler}
                                    stopHasMoreScenerioConditionally={
                                        forceFullyStopHasMoreShifts
                                    }
                                    setShiftLoader={setShiftLoader}
                                    handlePaginationMetadata={setPaginationMetadata}
                                    loadMoreRef={loadMoreRef}
                                    scrollThreshold={1}
                                    endMessage={'No more shifts to show'}
                                    loadingSpinner={true}
                                    children={
                                        <App
                                            events={events}
                                            resources={resources}
                                            currentSchedulerState={state}
                                            currentConfigOfScheduler={
                                                currentConfigOfScheduler
                                            }
                                            setCurrentConfigOfScheduler={
                                                setCurrentConfigOfScheduler
                                            }
                                            tabKey={state.tabKey}
                                            paginationMetadata={paginationMetadata}
                                            onLoadMore={handleLoadMore}
                                            isLoadingMore={ShiftLoader}
                                        />
                                    }
                                />
                            </div>

                            {/* <Col
                            span={24}
                            className="flex items-center justify-end"
                        >
                            <Pagination.Basic
                                total={paginate?.total}
                                pageSize={state?.limit}
                                current={state?.page}
                                onChange={paginationHandler}
                                showSizeChanger={''}
                                containerStyle={{ marginRight: '24px' }}
                            />
                        </Col> */}
                        </>
                    )}
            </Row>

            {/* Filter drawer */}
            <BasicDrawer
                openDrawer={drawerStates?.filter}
                onClose={() =>
                    setDrawerStates({ ...drawerStates, filter: false })
                }
                width={300}
                title={'Filters'}
                children={
                    <>
                        <Row
                            gutter={[16, 32]}
                            className="flex w-full flex-col h-full justify-between"
                        >
                            <Row gutter={[1, 12]} className="w-full">
                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        Schedule
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionSelectedBg:
                                                        colorPrimary,
                                                    optionActiveBg:
                                                        Colors.LightGray,
                                                    optionSelectedColor:
                                                        Colors.White,
                                                    selectorBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            className="w-full h-9 outline-none rounded"
                                            value={
                                                state?.filterDrawer?.schedule
                                            }
                                            onChange={(value) => {
                                                if (
                                                    value !== undefined &&
                                                    value !== null
                                                ) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            schedule: value,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            schedule: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            options={
                                                scheduleOptions
                                                    ? scheduleOptions
                                                    : []
                                            }
                                        />
                                    </ConfigProvider>
                                </Col>

                                {/* <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        User
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionSelectedBg:
                                                        colorPrimary,
                                                    optionActiveBg:
                                                        Colors.LightGray,
                                                    optionSelectedColor:
                                                        Colors.White,
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            className="w-full h-9 outline-none rounded"
                                            value={state?.filterDrawer?.user}
                                            onChange={(value) => {
                                                if (
                                                    value !== undefined &&
                                                    value !== null
                                                ) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            user: value,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            user: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            options={
                                                usersOptions ? usersOptions : []
                                            }
                                        />
                                    </ConfigProvider>
                                </Col> */}

                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        Position
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionSelectedBg:
                                                        colorPrimary,
                                                    optionActiveBg:
                                                        Colors.LightGray,
                                                    optionSelectedColor:
                                                        Colors.White,
                                                    selectorBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            className="w-full h-9 outline-none rounded"
                                            value={
                                                state?.filterDrawer?.eligiblity
                                            }
                                            onChange={(value) => {
                                                if (
                                                    value !== undefined &&
                                                    value !== null
                                                ) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            eligiblity: value,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            eligiblity: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            options={
                                                eligibilityOptions
                                                    ? eligibilityOptions
                                                    : []
                                            }
                                        />
                                    </ConfigProvider>
                                </Col>

                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        Job Site
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionSelectedBg:
                                                        colorPrimary,
                                                    optionActiveBg:
                                                        Colors.LightGray,
                                                    optionSelectedColor:
                                                        Colors.White,
                                                    selectorBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            className="w-full h-9 outline-none rounded"
                                            value={state?.filterDrawer?.jobSite}
                                            onChange={(value) => {
                                                if (
                                                    value !== undefined &&
                                                    value !== null
                                                ) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            jobSite: value,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            jobSite: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            options={
                                                propertiesOptions
                                                    ? propertiesOptions
                                                    : []
                                            }
                                        />
                                    </ConfigProvider>
                                </Col>

                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        Location
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionSelectedBg:
                                                        colorPrimary,
                                                    optionActiveBg:
                                                        Colors.LightGray,
                                                    optionSelectedColor:
                                                        Colors.White,
                                                    selectorBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            disabled={
                                                !state?.filterDrawer?.jobSite
                                            }
                                            className="w-full h-9 outline-none rounded"
                                            value={
                                                state?.filterDrawer?.location
                                            }
                                            onChange={(value) => {
                                                if (
                                                    value !== undefined &&
                                                    value !== null
                                                ) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            location: value,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            location: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            placeholder={
                                                !state?.filterDrawer?.jobSite
                                                    ? 'Select Job Site first'
                                                    : 'Select Location'
                                            }
                                            options={propertyLocations}
                                        />
                                    </ConfigProvider>
                                </Col>

                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        Shift Date
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                DatePicker: {
                                                    cellActiveWithRangeBg:
                                                        colorPrimary,
                                                    cellHoverBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <DatePicker
                                            allowClear={true}
                                            className="w-full h-9 outline-none rounded"
                                            value={
                                                state?.filterDrawer?.shiftDate
                                                    ? dayjs(
                                                        state?.filterDrawer
                                                            ?.shiftDate,
                                                    )
                                                    : null
                                            }
                                            onChange={(date, dateString) => {
                                                if (dateString) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            shiftDate:
                                                                dateString,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            shiftDate: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            format="YYYY-MM-DD"
                                        />
                                    </ConfigProvider>
                                </Col>
                            </Row>

                            <Row
                                className="w-full flex justify-between gap-4 px-2 self-end"
                                align={'middle'}
                            >
                                <Col span={11}>
                                    <Button.Basic
                                        onClick={incidentFilters}
                                        style={{
                                            color: 'white',
                                            backgroundColor: colorPrimary,
                                        }}
                                        text={'Search'}
                                        className={'w-full rounded'}
                                        size={'large'}
                                    />
                                </Col>
                                <Col span={11}>
                                    <Button.Basic
                                        onClick={clearFilters}
                                        style={{
                                            color: 'white',
                                            backgroundColor: Colors.Error,
                                        }}
                                        text={'Clear'}
                                        className={'w-full rounded'}
                                        size={'large'}
                                    />
                                </Col>
                            </Row>
                        </Row>
                    </>
                }
            />

            {/* Detail shift drawer only for the open shifts it will open in case of status is Applied  */}
            <DetailShiftDrawer
                drawerStates={drawerStates}
                setDrawerStates={setDrawerStates}
                openShiftDetailData={openShiftDetail}
                state={state}
                setOpenShiftDetail={setOpenShiftDetail}
                setState={setState}
            />
        </>
    );
};

export default MyShifts;
